import React, { useEffect } from 'react';
import { Typography, Fade, Grid } from '@material-ui/core';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';
import { LoadingScreenStyle } from './LoadingScreenStyle';
import loadingWM from './loadingWM.gif';
import { IState } from '../../../config/rootReducer';
import { MessageLoadingAction } from '../../../screens/Application/actions/ApplicationActions';

/* Componente usado cada vez que se lleva a cabo una carga de datos. 
Recibe como parámetros la variable que muestra o no el mensaje del componente
luego de que pasen 2 segundos, y la función que cambia esa variable. */
interface ILoadingScreen {
  readonly showMessage: boolean;
  readonly changeMessage: (show: boolean) => void;
}

const LoadingScreen = ({ showMessage, changeMessage }: ILoadingScreen) => {
  const classes = LoadingScreenStyle();
  useEffect(() => {
    changeMessage(false);
    const timerForMessage = setTimeout(() => changeMessage(true), 3000);

    return () => {
      clearTimeout(timerForMessage);
    };
  }, [changeMessage]);

  return (
    <Grid container={true} className={classes.fullPage}>
      <Grid item={true} className={classes.spaceBetweenGifAndText}>
        <img src={loadingWM} alt="Carga" height={90} />
      </Grid>
      <Grid item={true}>
        <Fade in={showMessage} timeout={1000}>
          <Typography className={classes.fadeInTextStyle}>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            Espere un momento <br />
            sus datos se están cargando
          </Typography>
        </Fade>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: IState) => {
  return {
    showMessage: state.application.messageLoading,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<IState, void, AnyAction>) => {
  return {
    changeMessage: (show: boolean) => dispatch(MessageLoadingAction(show)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingScreen);
